import { useCallback } from 'react';
import { css } from '@emotion/react';
import { QuickActionsNavMode } from '@frontend/quick-actions';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { AllAppsModule } from '../../../../components/dashboard/all-apps-module';
import { useNav } from '../providers/nav-provider';

type BubbleNavContentProps = {
  children: React.ReactNode;
};

export const BubbleNavContent = ({ children }: BubbleNavContentProps) => {
  const setOpen = useNav((state) => state.setOpen);

  return (
    <>
      <div
        css={css({
          display: 'flex',
          justifyContent: 'flex-end',
          padding: `${theme.spacing(1, 2, 0, 2)}`,
        })}
      >
        <Button onClick={() => setOpen(false)} iconName='x' size='large' variant='secondary' />
      </div>
      <div
        css={css({
          flex: 1,
          overflow: 'auto',
          padding: theme.spacing(3),
          paddingTop: theme.spacing(0.5),
        })}
      >
        {children}
      </div>
    </>
  );
};

export const BubbleNav = () => {
  const setOpen = useNav((state) => state.setOpen);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <BubbleNavContent>
      <AllAppsModule handleModalClose={handleClose} showHeader={false} />
      <QuickActionsNavMode onClick={handleClose} />
    </BubbleNavContent>
  );
};
